export function formatMarketingTargetologistName(accountName: string | null | undefined): string | null {
  if (!accountName) return null

  const trimmedName = accountName.trim()
  if (!trimmedName) return null

  const rawDisplayName = trimmedName.replace(/^(?:uid_\d+_)+/i, '').trim()
  if (!rawDisplayName) return trimmedName

  const underscoreIndex = rawDisplayName.lastIndexOf('_')
  const displayNameWithoutSuffix = underscoreIndex > 0
    ? rawDisplayName.slice(0, underscoreIndex).trim()
    : rawDisplayName

  const normalizedName = displayNameWithoutSuffix
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (!normalizedName) return trimmedName

  if (/^uid$/i.test(normalizedName)) {
    return null
  }

  return normalizedName
}
